<div class="row mt-4 grid grid-cols-1 lg:grid-cols-2">
    <div class="md:pr-[30px] pl-0" tourAnchor="deal.dashboard.largestPositions">
        <app-base-widget [error]="largestPositionsByRemainingValue?.error" data-cy="largestPositionWidget">
            <div header class="card-header flex border-b border-light-grey p-3">Largest Positions
                <app-info-icon tooltipPosition="above"
                    tooltipInfo="Top 5 largest unrealized asset positions for the Deal based on remaining value"
                    data-cy="largestPositionTooltip"  tooltipClass="mt-[3px]">
                </app-info-icon>
            </div>
            <span class="remaining-value-text">By Remaining Value</span>
            <app-gcm-chart [chartData]="largestPositionsByRemainingValue" [chartStyle]="chartStyle" chartType="funnel"
                [chartOptions]="largestPositionsByRemainingValueChartOptions"></app-gcm-chart>
        </app-base-widget>
    </div>
</div>